export default __webpack_public_path__ + "static/grandangolo-4-2fd4b2e3dafcbc20d71cd230fd04a50a.jpg";